<div class="subheader with-padding flgrow">
  <div class="row">
    <div class="col-lg-6 col-md-6 col-sm-8">
      <div class="relative flmid">
        <div class="flgrow row">
          <ng-select class=" col-5 ml-2" [(ngModel)]="selectedBrand" (change)="onBrandSelect()"
            placeholder="{{ 'lblSelectBrand' | translate }}">
            <option selected [ngValue]="null" translate>lblAllBrand</option>
            <ng-template ng-header-tmp>
              <span class="mbold w-66px">Code</span>
              <span class="mbold" translate>lblBrand</span>
            </ng-template>

            <ng-option *ngFor="let brand of brandList" [value]="brand.brandCode">
              <span class="w-66px">{{brand.brandCode}}</span>
              <span class="mx-2 hide-ng-dropdown-panel">-</span>
              <span>{{brand.brandName}}</span>
            </ng-option>
          </ng-select>

          <ng-select class=" col-5 ml-3" [(ngModel)]="selectedVehicleType" (change)="onVehicleTypeSelect()"
            placeholder="{{ 'lblVehicleType' | translate }}">
            <ng-template ng-header-tmp>
              <span class="mbold w-66px">Code</span>
              <span class="mbold" translate>lblVehicalType</span>
            </ng-template>

            <ng-option *ngFor="let item of vehicleTypeList" [value]="item.code">
              <span class="w-66px">{{item.code}}</span>
              <span class="mx-2 hide-ng-dropdown-panel">-</span>
              <span>{{item.name}}</span>
            </ng-option>
          </ng-select>

        </div>
      </div>
    </div>
    <div class="col-auto ml-auto" *ngIf="userRoleRightsDetails.canAdd">
      <button type="button" (click)="onAdd()" type="reset" class="add-button btn btn-primary" translate
        aria-label="Center Align">lblAddCheckList</button>
    </div>
  </div>
</div>
<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <div class="card-header d-flex" translate>
          lblCheckListmanagement
        </div>
        <div class="table-responsive">
          <table class="tablest1 table-hover">
            <thead>
              <tr>
                <th style="width: 30px" scope="col" class="pr-0"> </th>
                <th style="width: 55px" scope="col">#</th>
                <th style="width: 8%" scope="col" sortable="brand" (sort)="onSort($event)" translate>lblBrand</th>
                <th style="width: 10%" scope="col" sortable="vehicleType" (sort)="onSort($event)" translate>
                  lblVehicalType</th>
                <th style="width: 20%" scope="col" sortable="subCheckListTitle" (sort)="onSort($event)" translate>
                  lblCheckList
                </th>
                <th scope="col" translate>lblCheckListDescription </th>
                <th scope="col" translate *ngIf="showPredefinedChecklist">lblIsMultiColorCheckList</th>
                <th style="width: 150px" class="text-center" scope="col" translate>lblAction
                </th>
              </tr>
            </thead>
            <tbody>

              <ng-container *ngIf="checkList?.length>0; else load_else">
                <ng-container *ngFor="let check of checkList; let i=index" class="mb-3">
                  <tr [ngClass]="{'bg-info': check.expanded}" style="cursor: pointer;">
                    <td style="width:30px" class="pr-0" (click)="check.expanded = !check.expanded">
                      <a class="btn btn-ico" ngbTooltip="Show CheckList Item" tooltipClass="custom-revert">
                        <em class="fas fa-chevron-right fa-lg" [ngClass]="{'fa-chevron-up': check.expanded}"></em>
                      </a>
                    </td>
                    <td>{{ check.rowNumber }}</td>
                    <td class="nowrap">

                      <ng-container>
                        <span class="logo-icn">
                          <img af-brand-logo [data-code]="check.logo" data-type="BRAND"
                            class="{{check.logo}}-icon common"
                            [title]="check.logo" alt="" class="brandicon" />
                        </span>

                        <ngb-highlight [result]="check.logo" [term]="pService.searchTerm">
                        </ngb-highlight>

                      </ng-container>
                    </td>
                    <td>
                      <ngb-highlight [result]="check.vehicalType" [term]="pService.searchTerm">
                      </ngb-highlight>
                    </td>
                    <td>
                      <ngb-highlight [result]="check.subCheckListTitle" [term]="pService.searchTerm">
                      </ngb-highlight>
                    </td>
                    <td>
                      <ngb-highlight [result]="check.checkListDescription" [term]="pService.searchTerm">
                      </ngb-highlight>
                    </td>
                    <td *ngIf="showPredefinedChecklist">
                      <em class="fas fa-check"
                        [ngClass]="check.isMulticolorCheckListSelected ? 'predefine-checkList' : null"
                        *ngIf="check.isMulticolorCheckListSelected === true"></em>
                    </td>
                    <td class="nowrap text-center">
                      <a class="btn btn-ico" placement="top" (click)="duplicateCheckList(check)"
                        ngbTooltip="{{'lblDuplicateChecklist' | translate}}" aria-label="Center Align" *ngIf="userRoleRightsDetails.canAdd"> 
                        <em class="fas fa-copy fa-lg"></em>
                      </a>
                      <span class="ico-div" *ngIf="userRoleRightsDetails.canAdd"></span>
                      <a class="btn btn-ico" ngbTooltip="{{'lblAdd' | translate}}"
                        (click)="onAdditem(check,check.isMulticolorCheckListSelected)" *ngIf="userRoleRightsDetails.canAdd">
                        <em class="fas fa-plus fa-lg"></em>
                      </a>
                      <span class="ico-div" *ngIf="userRoleRightsDetails.canEdit"></span>
                      <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert"
                        *ngIf="userRoleRightsDetails.canEdit" (click)="editCheckList(check)">
                        <em class="fas fa-pencil-alt fa-lg"></em>
                      </a>
                      <span class="ico-div" *ngIf="userRoleRightsDetails.canDelete"></span>
                      <a class="btn btn-ico" ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert"
                        *ngIf="userRoleRightsDetails.canDelete" (click)="deleteCheckList(check.id)">
                        <em class="far fa-trash-alt fa-lg"></em>
                      </a>



                    </td>
                  </tr>
                  <ng-container *ngIf="check.expanded">
                    <tr class="table-active">

                      <td colspan="7" class="p-2 pl47">
                        <table class="tablest1 border">
                          <tr class="bg-light" *ngIf="check.checkListItems.length>0;else load_else">

                            <th style="width: 40px" scope="col">#</th>



                            <th translate scope="col">lblCheckListItemTitle</th>
                            <th style="width: 140px" class="text-center" scope="col" translate
                              *ngIf="!check.isMulticolorCheckListSelected">lblAction</th>
                          </tr>
                          <tr *ngFor="let item of check.checkListItems; let i=index" class="checkListItems">

                            <td>{{ i+1 }}</td>



                            <td>{{item.subCheckListItemTitle}}</td>
                            <td class="nowrap text-right pr-1" *ngIf="!check.isMulticolorCheckListSelected">
                              <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert"
                                *ngIf="userRoleRightsDetails.canEdit" (click)="editCheckListItem(check,item.id)">
                                <em class="fas fa-pencil-alt fa-lg"></em>
                              </a>
                              <span class="ico-div" *ngIf="userRoleRightsDetails.canDelete"></span>
                              <a class="btn btn-ico" ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert"
                                *ngIf="userRoleRightsDetails.canDelete" (click)="deleteCheckList(item.id)">
                                <em class="far fa-trash-alt fa-lg"></em>
                              </a>



                            </td>
                          </tr>
                        </table>
                      </td>

                    </tr>

                  </ng-container>
                </ng-container>
              </ng-container>
              <ng-template #load_else>
                <tr>
                  <td colspan="6" class="no-record" translate>lblNoRecordsFound</td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
        <div class="card-footer">
          <div class="d-flex justify-content-between">
            <div class="d-flex justify-content-between">
              <ngb-pagination [collectionSize]="pService.total$  | async" [(page)]="pService.page"
                [pageSize]="pService.pageSize" [maxSize]="3">
              </ngb-pagination>
              <select class="custom-select mx-2" style="width: auto" name="pageSize" [(ngModel)]="pService.pageSize">
                <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>{{item.label}}
                </option>
              </select>
            </div>
            <div class="d-flex justify-content-between p-2 font17 fontbold" style="margin: auto 0;">
              <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{pService.total$ | async}}&nbsp;<span
                class="font17 fontnormal" translate>lblResults</span>
            </div>
          </div>
        </div>

      </div>

    </div>
  </div>
</div>